import guilds from "./guilds.json";
import communities from "./communities.json";

const getGuildById = (id) => guilds.find((guild) => guild.id === id);
const getCommunitiesByGuild = (guildId) => communities.filter((community) => community.guildId === guildId);
const getCommunityById = (id) => communities.find((community) => community.id === id);

const guildFilters = {
  categories: Array.from(new Set(guilds.map((guild) => guild.category))).sort(),
  regions: Array.from(new Set(guilds.map((guild) => guild.regionFocus))).sort(),
  platforms: Array.from(new Set(guilds.flatMap((guild) => guild.platforms))).sort(),
  tags: Array.from(new Set(guilds.flatMap((guild) => guild.tags))).sort()
};

const communityFilters = {
  regions: Array.from(new Set(communities.map((community) => community.region))).sort(),
  platforms: Array.from(
    new Set(communities.flatMap((community) => community.platforms.map((platform) => platform.type)))
  ).sort(),
  tags: Array.from(new Set(communities.flatMap((community) => community.tags))).sort(),
  statuses: Array.from(new Set(communities.map((community) => community.status))).sort()
};

export {
  guilds,
  communities,
  guildFilters,
  communityFilters,
  getGuildById,
  getCommunitiesByGuild,
  getCommunityById
};
